import Vue from 'vue';
import VueRouter from 'vue-router';
import { routers } from './router';

import Util from '../lib/util';
import Cookies from 'js-cookie';
import { appRouters, otherRouters } from './router';

Vue.use(VueRouter);

const RouterConfig = {
  // mode: 'history',
  routes: routers,
};

export const router = new VueRouter(RouterConfig);
